import { Component, inject } from '@angular/core';
import { FloraSpecieService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FloraSpecieCreateDto,
  FloraSpecieDto,
  FloraSpecieExcelDownloadDto,
  FloraSpecieUpdateDto,
} from '../proxy/planning/dtos/flora-specie';
import { FLORASPECIE_CONFIG, FLORASPECIE_FIELDS } from './flora-specie.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-flora-specie',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FloraSpecieService, ConfirmationService],
  templateUrl: './flora-specie.html',
  styleUrl: './flora-specie.scss',
})
export class FloraSpecie extends BaseCrudComponent<
  FloraSpecieDto,
  FloraSpecieCreateDto,
  FloraSpecieUpdateDto,
  FloraSpecieExcelDownloadDto
> {
  service = inject(FloraSpecieService);
  config = FLORASPECIE_CONFIG;
  fields = FLORASPECIE_FIELDS;

  protected prepareUpdateDto(data: any, selected: FloraSpecieDto): FloraSpecieUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isNative: data.isNative,
      isPriority: data.isPriority,
      isThreaten: data.isThreaten,
      aaa: data.aaa,
      a1: data.a1,
      a2: data.a2,
      a3: data.a3,
      a4: data.a4,
      cites: data.cites,
      iucn: data.iucn,
      specieFamilyId: data.specieFamilyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FloraSpecie';
  }
}
